import React, {useEffect} from 'react';

import {LOAD_BAR} from '../../../constants/loadBar';
import {RECAPTCHA_ACTIONS} from '../../../constants/recaptcha';
import {BANK_TYPES} from '../../../constants/typesMessages';
import {useRecaptchaProtection} from '../../../hooks/useRecaptchaProtection';
import {sendBank} from '../../../services/Api';
import * as bankService from '../../../services/bank';
import {newCheckErrors} from '../../../services/errorsMessages';
import {useChatStore} from '../../../store/slices/chatStore';
import {useEcStore} from '../../../store/slices/ecStore';
import {useInteractionStore} from '../../../store/slices/interactionStore';

export const BankDetails = () => {
  const chatState = useChatStore((state) => state);
  const ecStateId = useEcStore((state) => state.ec.id);
  const updateEc = useEcStore((state) => state.updateEc);
  const setMessages = useChatStore((state) => state.setMessages);
  const setChatStageFlow = useChatStore((state) => state.setChatStageFlow);
  const responseFlowChange = useChatStore((state) => state.responseFlowChange);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const setDotTyping = useInteractionStore((state) => state.setDotTyping);
  const disabledButtonSendMessage = useInteractionStore(
    (state) => state.disabledButtonSendMessage
  );
  const {executeWithProtection} = useRecaptchaProtection();

  const bankSaveSuccess = (response) => {
    setDotTyping(false);
    setChatStageFlow(LOAD_BAR.BANK);
    updateEc(response.data);
    setMessages([
      {
        text: 'Para continuar, você precisa estar de acordo com os nossos Termos e Condições de Credenciamento e com a Política de Credenciamento do Estabelecimento Comercial.',
        type: 'terms-of-acceptance'
      }
    ]);
  };

  const bankSaveError = (error) => {
    setDotTyping(false);
    const showResponse = newCheckErrors(error, '');
    let messages = showResponse.messages;
    messages = bankService.getMessageQuestionBank(messages);
    messages = bankService.getMessageQuestionBankWarning(messages);

    setMessages(messages);
    responseFlowChange(BANK_TYPES.BANK_NAME);
    responseTypeChange(BANK_TYPES.BANK_FLOW);
    disabledButtonSendMessage('disabled');
  };

  const saveBankDetails = () => {
    setDotTyping(true);
    executeWithProtection(
      (payload, token) => sendBank(ecStateId, payload, token),
      RECAPTCHA_ACTIONS.FINANCIAL_DATA,
      chatState.bankObject
    )
      .then((response) => {
        bankSaveSuccess(response);
      })
      .catch((error) => {
        bankSaveError(error);
      });
  };

  useEffect(() => {
    saveBankDetails();
  }, []);

  return <></>;
};
